(function () {
  function boot() {
    var root = document.querySelector('.tw-mypage');
    if (!root) return;
    var details = root.querySelector('[data-profile-details]');
    function revealProfile() {
      if (details && window.location.hash === '#collector-profile-editor') details.open = true;
    }
    revealProfile();
    window.addEventListener('hashchange', revealProfile);
    var tabs = root.querySelector('[data-mypage-tabs]');
    if (!tabs) return;
    tabs.addEventListener('keydown', function (event) {
      if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
      var buttons = Array.from(tabs.querySelectorAll('[data-mypage-tab]'));
      var index = buttons.indexOf(event.target);
      if (index < 0) return;
      event.preventDefault();
      var next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + ((event.key === 'ArrowRight' || event.key === 'ArrowDown') ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next].click(); buttons[next].focus();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
